import React from 'react';
import styles from './ManageCreditNote.module.scss';

function ManageCreditNote() {
  return (
    <div className={styles.fieldNoteSection}>
      <h2>Notes:</h2>
      <ol>
        <li className={styles.fieldNoteEach}>
          Select The Credit Transaction Type accordingly.
        </li>
        <li className={styles.fieldNoteEach}>
          Add the Course Pause Credit/ Deduct the Course Pause Credit from the
          learner DB.
        </li>
        <li className={styles.fieldNoteEach}>
          Select the reason from the options present:
          <ul>
            <li className={styles.fieldNoteEach}>
              For custom reasons select the Other Reason option.
            </li>
            <li className={styles.fieldNoteEach}>
              Add the specific reason in the TextBox Below.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
}

export default ManageCreditNote;
